var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('polygon',{attrs:{"transform":"translate(11.920000, 11.920000) scale(-1, 1) translate(-11.920000, -11.920000) ","points":"19.84 10.92 19.84 12.92 7.84 12.92 13.34 18.42 11.92 19.84 4 11.92 11.92 4 13.34 5.42 7.84 10.92"}})])}
var staticRenderFns = []

export { render, staticRenderFns }